import env from "../../env"
import {SHA1} from 'crypto-js'

class CtrlCmd {
    ID = ""     // string generated by contructor
    Name = ""    // string
	Arg = ""   // json encoded arg string

    constructor(name, arg) {
        // console.log(`CtrlMsg constructor: Cmd: ${Cmd}, Args: ${Args}`)
        let r = new Date() + Math.random()
        this.ID = SHA1(r).toString()
        // console.log(`CtrlMsg constructor: random: ${r}, ID: ${this.ID}`)
        this.Name = name
        this.Arg = JSON.stringify(arg)
    }
}

class CtrlRet {
    Cmd // Ret for Cmd

    Result = {}
    Err = ""

    constructor(cmd, result, err) {
        this.Cmd = cmd
        this.Result = result
        this.Err = err
    }
}

// 同时只能设置 Cmd 或 Ret 中的一个才是有效的 CtrlMsg
class CtrlMsg {
    Cmd
    Ret
    IsSubCtrlMsg = false

    constructor(cmd, ret, isSubCtrlMsg) {
        this.Cmd = cmd
        this.Ret = ret
        this.IsSubCtrlMsg = isSubCtrlMsg
    }

    Encode() {
        return JSON.stringify(this)
    }

    NewRetMsg(retResult, retErr) {
        let ret = new CtrlRet(this.Cmd, retResult, retErr)
        let msg = new CtrlMsg(undefined, ret, this.IsSubCtrlMsg)
        // console.log("NewRetMsg: ret:", ret)
        // console.log("NewRetMsg: msg:", msg)
        return msg
    }

    static Decode(jsonStr) {
        let data = JSON.parse(jsonStr)
        let msg = new CtrlMsg(data.Cmd, data.Ret, data.IsSubCtrlMsg)
        return msg
    }
}

class Session {
    ID = ""
    ctrlPlane = undefined
    dataPlane = undefined
    ctrlPlaneURL = ""
    dataPlaneURL = ""

    vm = undefined  // Vue instance

    ctrlPlaneOnOpen = undefined
    ctrlPlaneOnClose = undefined
    ctrlPlaneOnError = undefined
    ctrlPlaneOnMessage = undefined
    dataPlaneOnOpen = undefined
    dataPlaneOnClose = undefined
    dataPlaneOnError = undefined
    dataPlaneOnMessage = undefined

    constructor(id, confPath, shellCmd) {
        // console.log(`session constructor: id: ${id}, confPath: ${confPath}`)
        this.ID = id
        this.ctrlPlaneURL = `${env.wsBaseUrl}/session/ctrlplane?sessId=${id}&sessPath=${confPath ? confPath : ""}&shellCmd=${shellCmd ? shellCmd : ""}`
        this.dataPlaneURL = `${env.wsBaseUrl}/session/dataplane?sessId=${id}`
    }

    Open(vm,
        ctrlPlaneOnOpen,
        ctrlPlaneOnClose,
        ctrlPlaneOnError,
        ctrlPlaneOnMessage,
        dataPlaneOnOpen,
        dataPlaneOnClose,
        dataPlaneOnError,
        dataPlaneOnMessage) {
        let self = this

        self.vm = vm
        self.ctrlPlaneOnOpen = ctrlPlaneOnOpen
        self.ctrlPlaneOnClose = ctrlPlaneOnClose
        self.ctrlPlaneOnError = ctrlPlaneOnError
        self.ctrlPlaneOnMessage = ctrlPlaneOnMessage
        self.dataPlaneOnOpen = dataPlaneOnOpen
        self.dataPlaneOnClose = dataPlaneOnClose
        self.dataPlaneOnError = dataPlaneOnError
        self.dataPlaneOnMessage = dataPlaneOnMessage

        self.ctrlPlane = new WebSocket(self.ctrlPlaneURL)
        self.ctrlPlane.onopen = () => {
            // console.log("ctrlplane onopen callback")
            self.ctrlPlaneOnOpen()

            self.dataPlane = new WebSocket(self.dataPlaneURL)
            // console.log("Session.Open self.dataPlane:", self.dataPlane)
            self.dataPlane.binaryType = "arraybuffer"
            self.dataPlane.onopen = self.dataPlaneOnOpen
            self.dataPlane.onclose = self.dataPlaneOnClose
            self.dataPlane.onerror = self.dataPlaneOnError
            self.dataPlane.onmessage = self.dataPlaneOnMessage
        }

        self.ctrlPlane.onclose = () => {
            self.dataPlane.close()
            self.ctrlPlaneOnClose()
        }

        self.ctrlPlane.onerror = (ev) => {
            self.dataPlane.close()
            self.ctrlPlaneOnError(ev)
        }

        self.ctrlPlane.onmessage = (ev) => {
            // console.log(`session ${this.ID} ctrlPlane message: ev: `, ev)
            // console.log(`session ${this.ID} ctrlPlane message: ev.data: `, ev.data)
            ev.data.text().then((text) => {
                // console.log("text:", text)
                let msg = CtrlMsg.Decode(text)
                if (msg.Cmd && msg.Ret) {
                    console.log("ctrlPlane.onmessage: Invalid CtrlMsg: Set CtrlMsg.Cmd and CtrlMsg.Ret at the same time")
                    return
                }

                // console.log("decoded msg:", msg)

                if (msg.Cmd) {
                    switch (msg.Cmd.Name) {
                        case "message":
                            this.vm.$message(msg.Cmd.Arg)
                            break
                        case "success":
                            this.vm.$message.success(msg.Cmd.Arg)
                            break
                        case "warning":
                            this.vm.$message.warning(msg.Cmd.Arg)
                            break
                        case "error":
                            this.vm.$message.error(msg.Cmd.Arg)
                            break
                        case "notify":
                            this.vm.$notify(JSON.parse(msg.Cmd.Arg))
                            break
                        case "notifyInfo":
                            this.vm.$notify.info(JSON.parse(msg.Cmd.Arg))
                            break
                        case "notifySuccess":
                            this.vm.$notify.success(JSON.parse(msg.Cmd.Arg))
                            break
                        case "notifyWarning":
                            this.vm.$notify.warning(JSON.parse(msg.Cmd.Arg))
                            break
                        case "notifyError":
                            this.vm.$notify.error(JSON.parse(msg.Cmd.Arg))
                            break
                    }
                }
                self.ctrlPlaneOnMessage(ev, msg)
            })


            // console.log(`session ${this.ID} ctrlPlane message: ev.data: `, ev.data)
        }
    }

    Close() {
        // console.log("Session close")
        this.dataPlane.close()
        this.ctrlPlane.close()
    }

    // Reconnect 如果 ctrlplane 和 dataplane 都断开, 则重新打开会话
    // 如果只是 dataplane 断开则只会重连会画面
    // 如果 datapalne 未断开则什么也不做
    Reconnect() {
        // console.log("Session reconnect: this.ctrlPlane.readyState:", this.ctrlPlane.readyState)
        if (this.dataPlane.readyState === this.dataPlane.OPEN) {
            // console.log("Session reconnect: do nothing")
            return
        }

        // ctrlplane 断开则 dataplane 也会被断开, 所以不存在 ctrlplane 断开但 dataplane 没断开的情况
        // ctrlplane 断开则意味着 ctrlplane 和 dataplane 都断开了, 此时重新打开 session
        if (this.ctrlPlane.readyState !== this.ctrlPlane.OPEN) {
            // console.log("Session reconnect: this.ctrlPlane.readyState !== this.ctrlPlane.OPEN")
            this.Open(this.vm,
                this.ctrlPlaneOnOpen,
                this.ctrlPlaneOnClose,
                this.ctrlPlaneOnError,
                this.ctrlPlaneOnMessage,
                this.dataPlaneOnOpen,
                this.dataPlaneOnClose,
                this.dataPlaneOnError,
                this.dataPlaneOnMessage)
            return
        }

        // console.log("Session reconnect: this.ctrlPlane.readyState !!== this.ctrlPlane.OPEN")
        // ctrlplane 没断开但 dataplane 断开了, 则只需要重连数据面, 重新初始化终端即可
        let dp = new WebSocket(this.dataPlaneURL)
        dp.binaryType = "arraybuffer"
        dp.onopen = this.dataPlaneOnOpen
        dp.onclose = this.dataPlaneOnClose
        dp.onerror = this.dataPlaneOnError
        dp.onmessage = this.dataPlaneOnMessage
        this.dataPlane = dp
    }

    Resize(cols, rows, x, y) {
        let cmd = new CtrlCmd("resize", {cols: cols, rows: rows, x: x, y: y})
        this.SendCtrlCmd(cmd)
    }

    SendCtrlCmd(ctrlCmd, isSubCtrlMsg) {
        let msg = new CtrlMsg(ctrlCmd, undefined, isSubCtrlMsg)
        // console.log("session.SendCtrlCmd: msg:", msg)
        this.ctrlPlane.send(msg.Encode())
    }

    SendCtrlRet(result, err, ctrlMsg) {
        let msg = ctrlMsg.NewRetMsg(result, err)
        // console.log("SendCtrlRet: msg.Encode():", msg.Encode())
        this.ctrlPlane.send(msg.Encode())
    }
}

export default {
    Session,
}
